import type { UnitCircleWidgetConfig } from '../unit-circle.model';

export const UNIT_CIRCLE_SIN_WAVE_TRACE_PRESET: UnitCircleWidgetConfig = {
  id: 'unit-circle-sin-wave-trace',
  type: 'unit-circle',
  params: {
    point: { angle: 0 },
    trigLines: { lines: ['sin'], referenceTriangle: true },
    traceWave: 'sin',
  },
  display: {
    coordinateSystem: {
      boundingbox: { xStart: -2, xEnd: 9, yStart: -2, yEnd: 2 },
      grid: { type: 'lines', visible: true },
    },
  },
};
